<template>
  <span v-if="role === 'superadmin'">
    <a :title="$t('status')"
       v-if="refundAndStatus"
       v-b-tooltip.hover
       @click="payStatus"
       class="tdclickable data-table-action">
      <ActivateSvg class="svg-light"/><span class="action-button-mob-title">{{ $t('status') }}</span>
    </a>
    <a :title="$t('return')"
       v-if="refundAndStatus && object.paid == 1 && !object.refunded_at"
       v-b-tooltip.hover
       @click="refundPayment"
       class="tdclickable data-table-action">
      <BackSvg class="svg-light"/><span class="action-button-mob-title">{{ $t('return') }}</span>
    </a>
    <a :title="object.confirmed ? $t('remove_confirmation') : $t('confirm')"
       v-b-tooltip.hover
       @click="paymentToggleConfirmation"
       class="tdclickable data-table-action">
      <BlockSvg v-if="object.confirmed"/>
      <ConfirmSvg class="svg-light" v-else/>
      <span class="action-button-mob-title">{{ object.confirmed ? $t('remove_confirmation') : $t('confirm') }}</span>
    </a>
    </span>
</template>

<script>

import ActivateSvg from '@/assets/svg-vue/header/note.svg'
import BackSvg from '@/assets/svg-vue/general/refresh2.svg'
import ConfirmSvg from '@/assets/svg-vue/form/tick.svg'
import {BillingService} from "@/services/api/billing.api.service"
import BlockSvg from "@/assets/svg-vue/general/block.svg.vue"

export default {
  name: "SuperAdminPaymentActions",
  components: {
    BlockSvg,
    ActivateSvg,
    BackSvg,
    ConfirmSvg
  },
  props: {
    object: {
      type: Object
    }
  },
  computed: {
    role() {
      return this.$store.state.auth.user.role
    },
    refundAndStatus() {
      return ['ioka','tinkoff'].includes(this.object.pay_system)
    }
  },
  methods: {
    async payStatus() {
      let res = await BillingService.paymentStatus(this.object.id, true)
      this.$store.commit('setPayStatus', res.data.status)
      this.$store.commit('setBillingPayment', res.data.payment)
      this.$nextTick(() => {
        this.$bvModal.show('pay-status-modal')
      })

    },
    async refundPayment() {
      if(confirm('Вы уверены, что хотите вернуть деньги?')) {
        let res = await BillingService.refundPay(this.object.id)
        if(res.data.id || res.data.Success) {
          this.$noty.info("Запрос на возврат принят")
        } else {
          this.$noty.error(res.data.message ? res.data.message : res.data.Details)
        }
        this.$store.commit('incrementDataTableCounter')
      }
    },
    async paymentToggleConfirmation() {
      try {
        const res = await BillingService.togglePaymentConfirm(this.object.id)
        this.object.confirmed = res.data
      } catch (e) {
        console.error(e)
      }
    }
  }
}
</script>

<style scoped>

</style>
